import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/SimpleConditionsContainer/SimpleConditionsContainer.tsx";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { useStore, useStoreMap } from 'effector-react';
import { getSourceGroupId } from "../../helpers/getSourceGroupId";
import { useElementPropertyList } from "../../helpers/useElementPropertyList";
import { BaseConditions } from "../../../../components";
import { importEstimationService } from "../../../../classifier-editor/ImportEstimation/model";
import { jsx as _jsx } from "react/jsx-runtime";
export var SimpleConditionsContainer = /*#__PURE__*/React.memo(function (_ref) {
  var currentGroup = _ref.currentGroup,
      readonly = _ref.readonly;
  var groupId = getSourceGroupId(currentGroup);
  var selectedPropertiesIds = useStoreMap({
    store: importEstimationService.activeEstimation$,
    keys: [groupId],
    fn: function fn(activeEstimation, _ref2) {
      var _activeEstimation$cal, _activeEstimation$cal2;

      var _ref3 = _slicedToArray(_ref2, 1),
          id = _ref3[0];

      return id && activeEstimation ? (activeEstimation === null || activeEstimation === void 0 ? void 0 : (_activeEstimation$cal = activeEstimation.calculations) === null || _activeEstimation$cal === void 0 ? void 0 : (_activeEstimation$cal2 = _activeEstimation$cal.find(function (calculation) {
        return calculation.groupId === groupId;
      })) === null || _activeEstimation$cal2 === void 0 ? void 0 : _activeEstimation$cal2.simpleFields.map(function (_ref4) {
        var elementPropertyId = _ref4.elementPropertyId;
        return elementPropertyId;
      })) || [] : [];
    }
  });
  var elementPropsMap = useStore(importEstimationService.estimationService.elementProps.byId$, {
    loc: {
      file: _effectorFileName,
      line: 52,
      column: 28
    },
    name: "SimpleConditionsContainer",
    sid: "SimpleConditionsContainer /src/classifier-editor/ImportEstimation/components/SimpleConditionsContainer/SimpleConditionsContainer.tsx [52, 28]"
  });

  var _useElementPropertyLi = useElementPropertyList(),
      propertyElementList = _useElementPropertyLi.propertyElementList,
      listPending = _useElementPropertyLi.pending;

  return /*#__PURE__*/_jsx(BaseConditions, {
    selectedPropertiesIds: selectedPropertiesIds // eslint-disable-next-line no-empty-function
    ,
    selectProperties: function selectProperties() {},
    availableProperties: propertyElementList,
    listPending: listPending,
    propertiesById: elementPropsMap,
    selectPending: false,
    title: "\u041F\u0440\u043E\u0441\u0442\u044B\u0435 \u043A\u043E\u043B\u043E\u043D\u043A\u0438",
    readonly: readonly
  });
});
SimpleConditionsContainer.displayName = 'SimpleConditionsContainer';